// Break string by comma and map to array of objects
// Grab short name before "due to" in each word in array
// Then perform a call to "/biomarkers" endpoint with "search" param for each short name to get its biomarker details
// Return rows data of failed tests with biomarker details (Biomarker name, Tube, Range, Result, Unit )

import { TUBE_LABELS } from "../../Biomarkers/CreateEdit/constants";

const failedTestsRows = async (failedTestsString, biomarkersService) => {
    if (!failedTestsString) return [];

    const failedTestsDetails = [];
    const failedTests = failedTestsString.split(",\n");

    for (const test of failedTests) {
        const [shortName, reason] = test.split(' due to ').map(s => s.trim());

        try {
            const response = await biomarkersService.getBiomarkers({
                search: shortName,
                limit: 1,
                offset: 0
            });
            if (response.data && response.data.length > 0) {
                const biomarkerData = response.data[0];
                const unitString = biomarkerData.unit ? (typeof biomarkerData.unit === 'object' ? (biomarkerData.unit.unit || '-') : biomarkerData.unit) : '-';
                // row matching the ResultsPopupBlood table structure
                failedTestsDetails.push({
                    biomarker: {
                        name: biomarkerData.name,
                        tube: TUBE_LABELS[biomarkerData.tube]
                    },
                    recommendationRange: 0, // "Untested" - no range
                    value: null, // No result value
                    unit: {
                        unit: unitString
                    },
                    //custom flag to identify untested rows
                    isUntested: true,
                    untestedReason: shortName + " due to " + reason.split("^")[0].trim(), // remove extra content after ^
                });
            }
        } catch (error) {
            console.error(`Error fetching biomarker ${shortName}:`, error);
        }
    }

    return failedTestsDetails;
};

export default failedTestsRows;